import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrecptedemandeComponent } from './precptedemande.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatChipsModule, MatTableModule, MatPaginatorModule, MatSelectModule, MatListModule, MatDatepickerModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { QuickInfoWidgetModule } from '../dashboard/widgets/quick-info-widget/quick-info-widget.module';
import { ShowenableprecompteComponent } from './showenableprecompte/showenableprecompte.component';

@NgModule({
  declarations: [PrecptedemandeComponent, ShowenableprecompteComponent],
  entryComponents: [ShowenableprecompteComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    ListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatListModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    QuickInfoWidgetModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FurySharedModule,
    MatInputModule,
    FormsModule,
    BrowserAnimationsModule
  ]
})
export class PrecptedemandeModule { }
